import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Input, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoginContext } from "../../../contexts/loginContext";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";

const DepartmentManagement = () => {
  // const { organizationId: Org_ID } = useContext(LoginContext);
  const [deptName, setDeptName] = useState("");
  const [dept_ID, setdeptId] = useState();
  const [deptData, setDeptData] = useState();

  // const [roleData, setRoleData] = useState([]);

  // const [roleName, setRoleName] = useState("");
  const [orgID, setOrgID] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [deactivateId, setDeactiveId] = useState("");
  const [editedId, setEditedId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [isActive, setIsActive] = useState("");
  const [Status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const Organization_ID = user?.organizationId;

  const aiDishaApi = createInstance("DISHA");

  useEffect(() => {
    fetchData();
    console.log("checking org id : ", Organization_ID);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(
        `/all-departments?organization_id=${Organization_ID}`
      );

      console.log("Fetched ORG dept data from API:", response.data);

      if (Array.isArray(response.data?.departments)) {
        setDeptData(response.data.departments);
      } else {
        console.error("Fetched data is not an array:", response.data);
        setDeptData([]); // Reset to an empty array if data is not an array
      }
    } catch (error) {
      console.error(
        "Error fetching role data:",
        error.response?.data?.message || error.message
      );
    }
  };
  // useEffect(() => {
  //   if (roleName === "" &&
  //     Status === "Active"
  //   ) {
  //     fetchData();
  //     setPage(0); // Reset pagination to the first page
  //     setIsEdit(false); // Exit edit mode
  //   }
  // }, [roleName, Status]);

  const handleSort = (field) => {
    const sortedData = [...deptData].sort((a, b) => {
      if (sortingOrder === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });
    setDeptData(sortedData);
    setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // Filter role data based on search term
  const filteredRoleData = Array.isArray(deptData)
    ? deptData.filter((role) =>
        role.department_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const handledepartmentSubmit = async () => {
    try {
      if (!Organization_ID.trim()) {
        console.error("Organization ID cannot be empty");
        Toast.error("Organization ID cannot be empty");
        return;
      }

      const response = await aiDishaApi.post(
        "/org-insert-department",
        {},
        {
          params: {
            organization_id: Organization_ID,
            department_name: deptName,
          },
        }
      );
      console.log("posted data", response);
      if (response.status === 200) {
        Toast.success("Role added successfully");
        setDeptName("");
        fetchData();
      }
    } catch (error) {
      Toast.error(error.response.data.detail);
      console.error("Error:", error);
    }
  };

  const handleEdit = (id, name) => {
    setdeptId(id);
    setEditedName(name);
    setDeptName(name);
    setIsEdit(true);
  };

  const handledeptEdit = async (dept_ID) => {
    try {
      // If the role name is unique, proceed with the update
      const updateResponse = await aiDishaApi.put(
        `/org-edit-department/${Organization_ID}/${dept_ID}`,
        {},
        {
          params: {
            department_name: deptName,
          },
        }
      );

      if (updateResponse.status === 200) {
        Toast.success("Department updated successfully");
        setDeptName("");
        fetchData();
        setIsEdit(false);
      }
      const updatedDeptData = deptData.map((role) => {
        if (role.department_id === dept_ID) {
          return { ...role, Department_Name: deptName };
        } else {
          return role;
        }
      });
      setDeptData(updatedDeptData);
      setIsEdit(false);
      setDeptName("");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setEditingRowId(null);
    }
  };

  const handleClear = () => {
    setDeptName("");
    setOrgID("");
    setdeptId("");
    setSearchTerm("");
  };

  const handleModalOpen = (Role_ID, status) => {
    console.log("decativacte clicked....");
    setDeactiveId(Role_ID);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDeactivateRole = async (dept_ID, selected_status) => {
    const newStatus = selected_status === "Active" ? "Inactive" : "Active";
    try {
      const response = await aiDishaApi.put(
        `/org-update-department-status/${Organization_ID}/${dept_ID}`,
        {},
        { params: { status: newStatus } } // ✅ query params go here
      );

      if (response.status === 200) {
        Toast.success("Department deactivated successfully");
        fetchData();
      }
      if (response.status === 200) {
        const updatedRoleData = deptData?.filter(
          (role) => role.department_id !== deactivateId
        );
        setDeptData(updatedRoleData);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const roleHeader = [
    {
      Org_ID: "Organization ID",
      dept_ID: "Department ID",
      Role_Name: "Department Name",
      Creation_Date: "Creation Date",
      isActive: "Status",
      Action: "Action",
    },
  ];

  const CssTextField = styled(TextField)({
    "& label": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
      "& .MuiInputBase-input": {
        color: "white",
      },
    },
  });

  return (
    <div>
      {isEdit ? (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            // background: "#006A71",
            background: "#033538", // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
            >
              Edit Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                backgroundColor: "#006A71", // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: "white", backgroundColor: "#006A71" }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  fontFamily: "Poppins",
                  color: "white",
                  backgroundColor: "#006A71",
                }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box
            gridColumn="span 5"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: "white" }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Department Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                width: "95%",

                // input text
                "& .MuiOutlinedInput-root": {
                  "& input": {
                    color: "white",
                  },
                },

                // outline
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                  borderRadius: "10px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "white",
                  },
              }}
              // 🔥 this part controls label color
              InputLabelProps={{
                sx: {
                  color: "white", // default
                  "&.Mui-focused": {
                    color: "white", // focused
                  },
                  "&.MuiFormLabel-filled": {
                    color: "white", // when it’s shrunk
                  },
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background: "#006A71",
                color: "black",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => handledeptEdit(dept_ID)}
            >
              <Typography sx={{ fontFamily: "poppins", color: "white" }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            // background: alpha("#B9B9B9", 0.2), // Opacity set to 20%,
            background: "#033538", // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
            >
              Add Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                backgroundColor: "#006A71", // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: "white" }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          {/* <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left" }}>
            <Typography sx={{ fontFamily: "poppins", color: "#B9B9B9" }}>
              Organization ID
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Organization ID"
              variant="outlined"
              value={orgID}
              onChange={(e) => setOrgID(e.target.value)}
              sx={{
                width: "75%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B9B9B9",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "grey",
                  },
              }}
              required
            />
          </Box> */}
          <Box
            gridColumn="span 4"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: "white" }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Department Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                width: "95%",

                // input text
                "& .MuiOutlinedInput-root": {
                  "& input": {
                    color: "white",
                  },
                },

                // outline
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                  borderRadius: "10px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "white",
                  },
              }}
              // 🔥 this part controls label color
              InputLabelProps={{
                sx: {
                  color: "white", // default
                  "&.Mui-focused": {
                    color: "white", // focused
                  },
                  "&.MuiFormLabel-filled": {
                    color: "white", // when it’s shrunk
                  },
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 2"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 2 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 2"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 2 }}
          >
            <Button
              sx={{
                background: "#006A71",
                color: "black",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={handledepartmentSubmit}
            >
              <Typography sx={{ fontFamily: "poppins", color: "white" }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      )}

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {roleHeader.map(
                    ({
                      Org_ID,
                      dept_ID,
                      Role_Name,
                      Creation_Date,
                      isActive,
                      Action,
                    }) => (
                      <React.Fragment key={Org_ID}>
                        {/* <TableCell sx={{ color: "#B9B9B9", borderBottom: 0 }}>
                        {Org_ID}
                      </TableCell> */}
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {dept_ID}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            borderBottom: 0,
                            cursor: "pointer",
                          }}
                          onClick={() => handleSort("role_name")}
                        >
                          {Role_Name} {sortingOrder === "asc" ? "↑" : "↓"}
                        </TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {Creation_Date}
                        </TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {isActive}
                        </TableCell>
                        <TableCell sx={{ color: "white", borderBottom: 0 }}>
                          {Action}
                        </TableCell>
                      </React.Fragment>
                    )
                  )}
                </TableHead>
                <TableBody>
                  {filteredRoleData &&
                    filteredRoleData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((n, index) => (
                        <TableRow
                          key={n.Org_ID}
                          sx={{
                            backgroundColor: "#033538",
                            marginRight: "30px",
                          }}
                        >
                          {/* <TableCell sx={{ color: "#A7A7A7", border: "1px solid black" }}>
                            {n.Org_ID}
                          </TableCell> */}
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {n.department_id}
                          </TableCell>
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {editingRowId === n.department_id ? (
                              <Input
                                value={editedName}
                                onChange={(e) => setEditedName(e.target.value)}
                              />
                            ) : (
                              n.department_name
                            )}
                          </TableCell>
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {new Date(n.creation_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell>
                          <TableCell
                            sx={{ color: "white", border: "1px solid black" }}
                          >
                            {n.status}
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "1px solid black",
                              borderRight: "1px solid black",
                              display: "flex",
                              alignItems: "center",
                              fontFamily: "poppins",
                            }}
                          >
                            {editingRowId === n.dept_ID ? (
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "black",
                                  color: "#A7A7A7",
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                onClick={() =>
                                  handleEdit(n.department_id, n.department_name)
                                }
                                sx={{
                                  backgroundColor: "black",
                                  color: "white",
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Edit
                              </Button>
                            )}
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  n.status === "Active" ? "#f44336" : "#4caf50",
                                color: "#ffffff",
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => {
                                console.log(
                                  "Deactivate button clicked for:",
                                  n.department_id,
                                  n.status
                                );
                                handleModalOpen(n.department_id, n.status);
                              }}
                            >
                              {/* Deactivate */}
                              {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredRoleData ? filteredRoleData.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        title="Department"
        action={() => handleDeactivateRole(deactivateId, selectedStatus)}
        actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};

export default DepartmentManagement;
